import React from "react"
import TrainingListItem from "./TrainingListItem"


export default function TrainingList({ trainings, getTrainings, getTrainingMetadata }) {
  return (
    <div id="TrainingList">
      { trainings.length ?
        <table className="qms-training-table">
          <thead>
            <tr className="qms-training-table-head">
              <th>Type</th>
              <th>Number</th>
              <th>Version</th>
              <th>Title</th>
              <th>Published</th>
            </tr>
          </thead>
          <tbody>
            { trainings.map(training => {
                return <TrainingListItem key={training.id} training={training} getTrainings={ getTrainings } getTrainingMetadata={ getTrainingMetadata }/>
            }) }
          </tbody>
        </table>
        :
        <h5>There are no trainings that match the search term.</h5>
      }
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/routes/qms-training/QMSTrainingManager/TrainingContainer/TrainingList.js